<template>

<div>

  <LDBsTable
    url="os-sw"
    defaultSort="id"
    defaultOrder="desc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="os_number">{{ $t('os_number') }}</label>
      <input
        type="text"
        id="os_number"
        name="os_number"
        class="form-control"
        :placeholder="$t('ph_os_number')"
        v-model="query.number"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="contract">{{ $t('contract') }}</label>
      <Combobox
        class="bg-white"
        name='contract'
        :placeholder="$t('select_a_item')"
        :options="os.contracts"
        :initial-value="query.contract"
        label="contracts"
        v-model="query.contract"
        :reduce="contract => contract.id_contrato"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="board">{{ $t('board') }}</label>
      <input
        type="text"
        id="board"
        name="board"
        class="form-control"
        :placeholder="$t('ph_board')"
        v-model="query.board"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="services">{{ $t('services') }}</label>
      <Combobox
        class="bg-white"
        name='services'
        :placeholder="$t('select_a_item')"
        :options="os.serviceTypes"
        :initial-value="query.services"
        label="name"
        v-model="query.services"
        :reduce="serviceType => serviceType.id"
      />
    </div>
  </LDBsTable>

  <!-- MODAL SHOW INFO -->
  <div
    class="modal fade"
    id="modalShowData"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalShowDataTitle"
    aria-hidden="true"
  >
    <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content bg-muted">

        <div class="modal-header">
          <h5 class="modal-title" id="modalShowDataTitle">OS - Informações</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <b-list-group>
                <b-list-group-item>Marca: {{ osPreview.brand || 'Não informado' }}</b-list-group-item>
                <b-list-group-item>Modelo: {{ osPreview.model || 'Não informado' }}</b-list-group-item>
                <b-list-group-item>Cor: {{ osPreview.color || 'Não informado' }}</b-list-group-item>
                <b-list-group-item>Ano: {{ osPreview.year || 'Não informado' }}</b-list-group-item>
              </b-list-group>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary btn-form"
            data-dismiss='modal'
          >
            {{ $t('close') }}
          </button>
        </div>

      </div>
    </div>
  </div>
</div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import moment from 'moment'

export default {
  name: 'OsSWList',
  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('os'),
          field: 'id',
          width: '50%',
          sortable: true
        },
        {
          title: this.$t('contract'),
          field: 'contract',
          formatter: function(value) {
            return value.contracts
          },
          sortable: true
        },
        {
          title: this.$t('board'),
          field: 'board',
          formatter: value => {            
            return value.length === 7 
              ? value.substr(0,3)+"-"+value.substr(3,7)
              : value
          }
        },
        {
          title: this.$t('vehicle_type'),
          field: 'vehicleType',
          formatter: function(value) {
            return 'SEM RASTREADOR'
          }
        },
        {
          title: this.$t('services'),
          field: 'service',
          formatter: function(value) {
            return value.name
          },
          sortable: true
        },
        {
          title: 'Data Instalação/Retirada',
          field: 'testDate',
          formatter: function(value) {
            return value && moment(value).format('DD/MM/YYYY')
          },
          sortable: true
        },
        {
          title: 'Veículo Reutilizado',
          field: 'vehicleReuse',
          formatter: value => value ? value : '-' 
        },
        {
          title: 'Usuário',
          field: 'createdBy',
          formatter: function(value) {
            return value.name || ''
          }
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value, row) {
            return `
              <button
                title="Cancelar"
                data-target="#modalShowData"
                data-id='${value}'
                data-toggle="modal"
                class="mb-1 btn btn-action btn-primary btn-circle light-bottom-shadow text-white">
                <i class="fas fa-eye" />
              </button>
            `
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'OS-SW' }
      },
      query: {
        id              : '',
        number          : '',
        contract        : '',
        board           : '',
        services        : ''
      },
      loading: false,
      osPreview: {}
    }
  },

  computed: {
    ...mapState({
      os: state => state.ossw.all,
      allBsTable: state => state.bstable.all
    })
  },

  methods: {
    ...mapActions('os', [ 'inactivate', 'cleanState' ]),

    clear() {
      this.query.number   = undefined
      this.query.contract = ''
      this.query.board    = ''
      this.query.services = ''
      this.query.testDate = ''
    },

    mountInfoOS(id) {
      let osFounded = this.allBsTable.rows.find(item => item.id === id)
      let vehicleBrand = osFounded.brand
      
      if (osFounded.brand) {
        const vehicleBrandFounded = this.os.vehicleBrands.find(brand => brand.id === osFounded.brand)

        vehicleBrand = vehicleBrandFounded.name
      }

      this.osPreview = { ...osFounded, brand: vehicleBrand }
    }
  },

  async mounted () {
    const { dispatch } = this.$store
    
    dispatch('overlay/show', true)

    await dispatch('ossw/fetchAllPageOsSWList')

    dispatch('overlay/show', false)

    const global = this
    $('#modalShowData').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      const modal = $(this)
      const id = button.data('id')

      modal.find('#modalShowDataTitle').text(`OS ${id} - Informações`)

      global.mountInfoOS(id)
    })
  },

  destroyed () {
    const { dispatch } = this.$store

    dispatch('maintancereason/cleanState'),
    dispatch('contracts/cleanState'),
    dispatch('vehicletypes/cleanState'),
    dispatch('garageaccredited/cleanState'),
    dispatch('servicetypes/cleanState'),
    dispatch('statusostests/cleanState'),
    dispatch('os/cleanState')
  }
}
</script>